import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // animation:false makes hide() run synchronously. Bootstrap's animated
    // path schedules a transitionend/setTimeout callback that dispose() does
    // not cancel; on rapid connect/disconnect that callback fires after
    // dispose() nulls _activeTrigger, throwing "Cannot convert undefined or
    // null to object". Disabling animation removes the deferred callback.
    // (RP-DASH-55)
    this.tooltip = new bootstrap.Tooltip(this.element, { animation: false })
  }

  disconnect() {
    if (this.tooltip) {
      this.tooltip.dispose()
    }
  }
}
